import SalesChannelCard from "./SalesChannelCard";

export default SalesChannelCard;
